import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLbryComponent } from './simple-icons-lbry.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLbryComponent ],
    exports:      [ SimpleIconsLbryComponent ],
    bootstrap:    []
})
export class SimpleIconsLbryModule {}
